<template>
  <a-config-provider :locale="locale">
    <div id="app">
      <KeepAlive>
        <router-view />
      </KeepAlive>
    </div>
  </a-config-provider>
</template>

<script>
  import Vue from 'vue'
  import { AppDeviceEnquire } from '@/utils/mixin'
  import { mixin as langMixin } from '@/store/i18n-mixin'
  import { getAntLangs, defaultLang } from './locales'
  import SignModal from '@/plugs/sign_modal/SignModal'
  import store from './store'
  import hotkeys from 'hotkeys-js'
  import { SCREEN_HEIGHT, WAREHOUSE } from '@/store/mutation-types'
  import { message } from 'ant-design-vue'

  hotkeys('ctrl+k', function(event, handler) {
    const keys = 'ctrl+k'
    if (Vue.ls.get(WAREHOUSE)) {
      store.dispatch('UpdateHotKeys', { keys })
    }
    return false
  })
  export default {
    components: { SignModal },
    mixins: [AppDeviceEnquire, langMixin],
    data() {
      return {
        locale: getAntLangs(defaultLang)
      }
    },
    created() {
      this.locale = getAntLangs(defaultLang)
      this.setLang(defaultLang)
      Vue.ls.set(SCREEN_HEIGHT, document.body.clientHeight)
      message.config({ top: '50%' })
      window.addEventListener('beforeunload', () => {
        localStorage.clear();
        sessionStorage.clear();
      });
    },
    watch: {
      '$store.getters.lang': function(newValue) {
        this.getLocale(newValue)
      },
      '$store.getters.hotKeys': function(newValue) {
        if (newValue.keys === 'ctrl+k') {
          this.$router.push('/settings/inventoryQuery')
        }
      }
    },
    methods: {
      getLocale(lang) {
        this.locale = getAntLangs(lang)
      }
    }
  }
</script>
<style>
  #app {
    height: 100%;
  }
</style>